import Vue from 'vue';
import {
  Button,
  Form,
  Field,
  Divider,
  Empty,
  Icon,
  Card,
  Tab,
  Tabs,
  Popup,
  NumberKeyboard,
  NavBar,
  Toast,
  Dialog,
  Lazyload,
  Loading,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  List,
  Cell,
} from 'vant';
import '@vant/touch-emulator'; // 桌面端适配--事件转换适配
import router from './router';
import App from './App.vue';
import './assets/style/index.less';
import moment from 'moment';

// 全局 moment 配置
moment.locale('zh-cn', {
  longDateFormat: {
    l: 'YYYY-MM-DD',
    L: 'YYYY-MM-DD HH:mm:ss',
  },
});

Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Divider);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(NumberKeyboard);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(List);
Vue.use(Cell);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
